import cloneDeep from 'lodash/cloneDeep';

import { mapCategory, mapCol, mapCondition, mapRow } from '@webapp/common/lib/map';
import type { Question } from '@webapp/common/resources/entities/question';
import { initialQuestion } from '@webapp/common/resources/entities/question';
import type { QuestionType } from '@webapp/common/resources/survey';

export const mapQuestion = (data: any): Question => {
    const {
        answers,
        groups,
        categories,
        ID,
        logics,
        PAGE,
        parameters: { params },
        QUESTION,
        QUESTION_TYPE_ID,
    } = data;
    const question: Question = {
        ...cloneDeep(initialQuestion),
        typeMode: false,
        id: ID,
        name: QUESTION === null ? '' : QUESTION,
        pageId: PAGE,
        type: QUESTION_TYPE_ID as QuestionType,
        rows: answers.map(mapRow),
        cols: groups.map(mapCol),
        conditions: logics.map((logic: any) => mapCondition(logic, data)),
        categories: categories?.map(mapCategory),
    };

    if (params) {
        try {
            question.params = Object.assign(cloneDeep(initialQuestion.params), JSON.parse(params));
        } catch (e) {
            console.error(e);
        }
    }

    return question;
};
